import React from 'react';
import clsx from 'clsx';
import { Button as KendoButton } from '@progress/kendo-react-buttons';
import styles from './Button.module.css';
import type { ButtonProps } from './Button.types';

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  styleType = 'filled',
  onClick,
  disabled = false,
  className = '',
  ariaLabel,
  type = 'button',
  collapsed = false,
  iconOnly = false,
}) => {
  const rootClass = clsx(styles.button, styles[styleType], styles[variant], 'p2', 'p-tb', 'p-lr', className);

  return (
    <KendoButton
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={rootClass}
      aria-label={ariaLabel}
      data-collapsed={collapsed ? 'true' : undefined}
      data-icon-only={iconOnly ? 'true' : undefined}
    >
      <span className="inline-flex items-center justify-center gap-8">{children}</span>
    </KendoButton>
  );
};
